import { ItemValue, Modal, Card, ExternalLink } from '../../../components';
import { Fragment } from 'react';
import { Fade, Grid, Divider, Box } from '@mui/material';
import { Map } from '@mui/icons-material';
import { formatShortFriendlyDateWithTime, unCamelCase } from '../../../helpers';
import { IRecentItem } from '../../../models';

export const DetailsModal = ({
  recentItem,
  setRecentItem
}: {
  recentItem: IRecentItem | null;
  setRecentItem: (val: null) => void;
}) => {
  return (
    <Modal
      open={!!recentItem}
      onClose={() => setRecentItem(null)}
      title={`Activity Tracking Details`}
      maxWidth="lg"
    >
      <Fade in={!!recentItem}>
        <Box mt={1}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Card title="Info">
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <ItemValue
                      label="Activity Date/Time"
                      value={
                        recentItem?.whenAccessed
                          ? formatShortFriendlyDateWithTime(recentItem.whenAccessed)
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="User" value={recentItem?.displayName ?? ''} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="Record" value={recentItem?.description ?? ''} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card title="Geolocation Info">
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="Region" value={recentItem?.regionName ?? ''} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="City" value={recentItem?.city ?? ''} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="Country Code" value={recentItem?.countryCode ?? ''} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="ZIP Code" value={recentItem?.zipCode ?? ''} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue
                      label="Location"
                      value={
                        <>
                          {recentItem?.latitude && recentItem?.longitude ? (
                            <ExternalLink
                              type="secondary"
                              target="_blank"
                              to={`https://maps.google.com/?q=${recentItem.latitude},${recentItem.longitude}`}
                              title="View Map on Google Maps"
                              className="print--none"
                            >
                              <Box component="span" display="flex" alignItems="center">
                                <Map sx={{ marginRight: '5px' }} /> Map
                              </Box>
                            </ExternalLink>
                          ) : (
                            <></>
                          )}
                        </>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="ISP" value={recentItem?.internetServiceProvider ?? ''} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="IP Address" value={recentItem?.ipAddress ?? ''} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="Hosting" value={recentItem?.isHosting ? 'Yes' : 'No'} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="Mobile" value={recentItem?.isMobile ? 'Yes' : 'No'} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ItemValue label="Organization" value={recentItem?.organization ?? ''} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            {recentItem?.changes?.length > 0 && (
              <Grid item xs={12}>
                <Card title="Changes">
                  <Grid container spacing={1}>
                    {recentItem?.changes?.map((change, index) => {
                      return (
                        <Fragment key={`${index}`}>
                          <Grid item xs={12} sm={6}>
                            <ItemValue
                              label="Activty Type"
                              value={change.recordType ? unCamelCase(change.recordType) : ''}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ItemValue
                              label="Field"
                              value={change.fieldName ? unCamelCase(change.fieldName) : ''}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ItemValue
                              label="Old Value"
                              value={
                                change.oldValue?.includes('|')
                                  ? change.oldValue?.split('|')?.join(', ')
                                  : change.oldValue
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ItemValue
                              label="New Value"
                              value={
                                change.newValue?.includes('|')
                                  ? change.newValue?.split('|')?.join(', ')
                                  : change.newValue
                              }
                            />
                          </Grid>
                          {recentItem?.changes?.length - 1 !== index && (
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          )}
                        </Fragment>
                      );
                    })}
                  </Grid>
                </Card>
              </Grid>
            )}
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
